module.exports = __webpack_public_path__ + "static/img/008.526b648c.jpg";